// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-home-index-js" + "-" + "3fe3010c16e6011df84e" + ".js";
};